import {Carousel} from '@bonprix/design-system';

export default function ProductCardImageSlider({item}) {

    const uuid = crypto.randomUUID();

    const images = item.productImages.map((image,index) => {

        const sources = image.imagePaths.map((path, index2) => {
            return (
                <source
                    media={'(' + path.mediaQuery + ')'}
                    srcSet={path.plainPath + ' 1x, ' + path.retinaPath + ' 2x'}
                    key={`${uuid}-source-${index2}`}
                />
            );
        });


        return (
            <Carousel.Slide key={`${uuid}-${index}`}>
                <div className="product-card_image-wrapper">
                    <div className="product-card_image-container">

                        <picture className={"product-card_image"}>
                            {sources}
                            <img
                                src={image.defaultImagePath}
                                alt={item.title + " - Bild " + (index + 1)}
                            />
                        </picture>
                    </div>
                </div>
            </Carousel.Slide>
        );
    })

    return (
        <div className="product-card_slider-content-wrapper">
            <div
                className={'product-card_slider-content'}
            >
                <Carousel
                    label={"Product Card Image Carousel"}
                    rewind={true}
                    arrows={false}
                    pagination={false}
                >
                    {images}
                </Carousel>
            </div>
        </div>
    )
}
